import { render, staticRenderFns } from "./PosDebtBalancePayHistory.vue?vue&type=template&id=0f5bae1a&scoped=true&"
import script from "./PosDebtBalancePayHistory.vue?vue&type=script&lang=js&"
export * from "./PosDebtBalancePayHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5bae1a",
  null
  
)

export default component.exports